(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
module.exports = {
  get(url, params){
    return new Promise(resolve => {
      const newUrl = `/interface${url}`;
      $.ajax({
        url: newUrl, data: params, dataType: 'json', type: 'get',
        success(result, status, xhr){
          resolve({err: null, res: result});
        },
        error(xhr, status, error){
          resolve({err: error, res: null});
        }
      })
    });
  },
  post(url, params){
    return new Promise(resolve => {
      const newUrl = `/interface${url}`;
      $.ajax({
        url: newUrl, data: params, dataType: 'json', type: 'post',
        success(result, status, xhr){
          resolve({err: null, res: result});
        },
        error(xhr, status, error){
          resolve({err: error, res: null});
        }
      })
    });
  }
};
},{}],2:[function(require,module,exports){
const init = () => {
  const message = require('./message');
  const ajaxSync = require('./ajaxSync');
  $.extend({message, ajaxSync});
};
module.exports = {init};
},{"./ajaxSync":1,"./message":3}],3:[function(require,module,exports){
const isMobile = $('body').hasClass('mobile-body');
module.exports = {
  success(msg){

  },
  error(msg){

  },
  warn(msg){

  },
  alert(msg, time = 2){
    if (isMobile) {
      return layer.open({
        content: msg, skin: 'msg', time
      });
    } else {
      return layer.alert(msg);
    }
  }
};
},{}],4:[function(require,module,exports){
const jqueryExtend = require('./jqueryExtend/index');
const common = require('./source/common');
const index = require('./source/index');
const news = require('./source/news');
const information = require('./source/information');
const product = require('./source/product');
const sysLoginIcon = require('./source/sysLoginIcon');
const apiCache = require('./source/apiCache');
$(function () {
  jqueryExtend.init();
  common.init();
  index.init();
  news.init();
  information.init();
  product.init();
  sysLoginIcon.init();
  apiCache.init();
});
},{"./jqueryExtend/index":2,"./source/apiCache":5,"./source/common":6,"./source/index":9,"./source/information":10,"./source/news":11,"./source/product":12,"./source/sysLoginIcon":13}],5:[function(require,module,exports){
const init = () => {
  $('#clearCacheLink').on('click', () => {
    $.ajax({
      url: '/apiCache/clearAll',
      dataType: 'jsonp',
      success: (res) => {
        console.log(res);
      }
    })
  });
};
module.exports = {init};
},{}],6:[function(require,module,exports){
const init = () => {
  const globalData = require('./globalData');
  const eventBus = require('./eventBus');
  const $win = $(window);
  $win.on('resize', () => {
    const [width, height] = [$win.width(), $win.height()];
    globalData.set('windowSize', {width, height});
    eventBus.trigger('resize');
  });
};
module.exports = {init};
},{"./eventBus":7,"./globalData":8}],7:[function(require,module,exports){
let eventList = [];
module.exports = {
  on(eventName, callback){
    eventList.push({eventName, callback});
    return this;
  },
  off(eventName, callback){
    eventList = eventList.filter(item => {
      if (item.eventName === eventName) {
        if (!callback || (callback && callback === item.callback)) {
          return false;
        }
      }
      return true;
    });
    return this;
  },
  trigger(eventName, props){
    eventList.forEach(item => {
      if (item.eventName === eventName) {
        item.callback(props);
      }
    });
    return this;
  }
};
},{}],8:[function(require,module,exports){
const globalData = {};
module.exports = {
  get(key){
    return globalData[key];
  },
  set(key, value){
    globalData[key] = value;
    return this;
  }
};
},{}],9:[function(require,module,exports){
// 移动端点击某个系统
function mobileSystemClick() {
  $('.mobile-body .system-list').on('click', '.system-item', function(event) {
    event.preventDefault();
    $('.mobile-body .system-list .system-item.active').removeClass('active');
    $(this).addClass('active');
    $.message.alert('请在电脑端进行登录');
  });
}
// 头部登录按钮点击
function headerLoginInit() {
  //
  $('.pc-body .header .login-button').on('click', () => {
  });
  // 移动端暂时不支持登录
  $('.mobile-body .header .login-button').on('click', () => {
    $.message.alert('请在电脑端进行登录');
  });
}
// 手机页面头部导航
function mobileHeaderNavInit() {
  $('.header .list-icon').on('click', () => {
    layer.open({
      type: 1,
      content: $('.nav-template').html(),
      anim: false,
      className: 'nav-layer'
    });
  });
}
// 轮播图
function carouselImageInit() {
  $('.carousel-image-container').each(function(index) {
    const className = `carousel-image-index-${index}`;
    $(this).addClass(className);
    const slides = $(this).find('.swiper-slide');
    if (slides.length < 2) {
      $(this).find('.swiper-pagination').hide();
    }
    const swiper = new Swiper(`.${className}`, {
      loop: slides.length > 1,
      autoplay: slides.length > 1,
      pagination: {el: `.${className} .swiper-pagination`}
    });
  });
}
// 返回顶部
function toTopInit() {
  $('.go-top').on('click', () => {
    $('html,body').animate({scrollTop: 0}, 500);
  });
}

// 专家咨询 打开关闭切换
function expertConsultationToggle() {
  var $ec = $('.expert-consultation');
  $ec.on('click', '.consultation-online', () => {
    $ec.toggleClass('show-left');
  }).on('click', '.expert-consultation-close-icon', () => {
    $ec.removeClass('show-left');
  });
}

// 查询码
function searchCode() {
  const $searBtn = $('.search-button');
  $searBtn.click(function() {
    const $input = $(this).parent().find('.search-input');
    const inputValue = $.trim($input.val());
    const codeLength = inputValue.length;
    const traceLink = $input.attr('data-trace');
    const antiLink = $input.attr('data-antifake');
    if (codeLength === 0) {
      $.message.alert('请输入码查询');
    } else if (codeLength === 18 || codeLength === 16 || codeLength === 20) {
      window.location.href = traceLink + '?code=' + inputValue;
    } else if (codeLength === 21 || codeLength === 17 || codeLength === 19) {
      window.location.href = antiLink + '?code=' + inputValue;
    } else {
      $.message.alert('该码不正确!');
    }
  });
}

const init = () => {
  mobileSystemClick();
  headerLoginInit();
  mobileHeaderNavInit();
  carouselImageInit();
  toTopInit();
  expertConsultationToggle();
  searchCode();
};
module.exports = {init};

},{}],10:[function(require,module,exports){
//判断是否滚动到底部
function isScrollEnd($dom) {
  const $win = $(window);
  const windowHeight = $win.height();
  const domHeight = $dom.height();
  const domTop = $dom.offset().top;
  const scrollTop = $win.scrollTop();
  if (scrollTop + windowHeight > domHeight + domTop) {
    return true;
  }
  return false;
}
//加载下一页数据
let isLoading = false;
let currentPage, totalPage;
function loadNextPage($dom) {
  isLoading = true;
  currentPage = $dom.data('page') || 1;
  const loadPage = currentPage + 1;
  const cardId = $dom.attr('data-cardId');
  const organizationId = $dom.attr('data-organizationId');
  $.ajaxSync.get('/information/load/list', {page: loadPage, cardId, organizationId}).then(({res}) => {
    isLoading = false;
    $dom.data('page', loadPage);
    const listData = res.data.results.list ? res.data.results.list : [];
    totalPage = res.data.results.pagination.totalPage;
    listData.map((list) => {
      var imgList = list.titleImageUrl ? '<a href="/information/' + list.publishInformationId + '"><img src="' + fileDomain + list.titleImageUrl + '"/></a>' : '';

      var htmlText = '<div class="information-item">' +
                          '<div class="information-title">' + list.title + '</div>' +
                          '<div class="information-images">' +
                              imgList +
                          '</div>' +
                          '<div class="information-short-info">' +
                              '<div class="create-time"><i class="s3-icon-clock"></i>&nbsp;&nbsp;发布时间：' + list.publishDatetime + '</div>' +
                              '<div class="view-count"><i class="s3-icon-eye"></i>&nbsp;&nbsp;' + list.clickNumber + '</div>' +
                          '</div>' +
                      '</div>';
      $dom.append(htmlText);
    })
  });
}
const init = () => {
  const $wrap = $('.information-list.scroll-loading');
  if ($wrap.length) {
    $(window).on('scroll', () => {
      $wrap.each(function () {
        if (!isLoading && isScrollEnd($(this))) {
          if (!totalPage || totalPage > currentPage) {
            loadNextPage($(this));
          }
        }
      });
    });
  }
};
module.exports = {init};
},{}],11:[function(require,module,exports){
// 判断是否滚动到底部
function isScrollEnd($dom) {
  const $win = $(window);
  const windowHeight = $win.height();
  const domHeight = $dom.height();
  const domTop = $dom.offset().top;
  const scrollTop = $win.scrollTop();
  if (scrollTop + windowHeight > domHeight + domTop) {
    return true;
  }
  return false;
}
// 加载下一页数据
let isLoading = false;
let currentPage, totalPage;
function loadNextPage($dom) {
  isLoading = true;
  currentPage = $dom.data('page') || 1;
  const loadPage = currentPage + 1;
  const cardId = $dom.attr('data-cardId');
  const organizationId = $dom.attr('data-organizationId');
  $.ajaxSync.get('/news/load/list', {page: loadPage, cardId, organizationId}).then(({res}) => {
    isLoading = false;
    $dom.data('page', loadPage);

    const listData = res.data.results.list ? res.data.results.list : [];
    totalPage = res.data.results.pagination.totalPage;
    listData.map((list) => {
      var imgList = list.titleImageUrl ? '<a href="/news/' + list.newsId + '"><img src="' + fileDomain + list.titleImageUrl + '"/></a>' +
          '<a href="/news/' + list.newsId + '"><img src="' + fileDomain + list.titleImageUrl + '"/></a>' +
          '<a href="/news/' + list.newsId + '"><img src="' + fileDomain + list.titleImageUrl + '"/></a>' : '';

      var htmlText = '<div class="news-item">' +
                          '<div class="news-title">' + list.title + '</div>' +
                          '<div class="news-images">' +
                              imgList +
                          '</div>' +
                          '<div class="news-short-info">' +
                              '<div class="create-time"><i class="s3-icon-clock"></i>&nbsp;&nbsp;发布时间：' + list.publishDatetime + '</div>' +
                              '<div class="view-count"><i class="s3-icon-eye"></i>&nbsp;&nbsp;' + list.clickNumber + '</div>' +
                          '</div>' +
                      '</div>';
      $dom.append(htmlText);
    })
  });
}
const init = () => {
  const $wrap = $('.news-list.scroll-loading');
  if ($wrap.length) {
    $(window).on('scroll', () => {
      $wrap.each(function () {
        if (!isLoading && isScrollEnd($(this))) {
          if (!totalPage || totalPage > currentPage) {
            loadNextPage($(this));
          }
        }
      });
    });
  }
};
module.exports = {init};
},{}],12:[function(require,module,exports){
//判断是否滚动到底部
function isScrollEnd($dom) {
  const $win = $(window);
  const windowHeight = $win.height();
  const domHeight = $dom.height();
  const domTop = $dom.offset().top;
  const scrollTop = $win.scrollTop();
  if (scrollTop + windowHeight > domHeight + domTop) {
    return true;
  }
  return false;
}
//加载下一页数据
let isLoading = false;
let currentPage, totalPage;
function loadNextPage($dom) {
  isLoading = true;
  currentPage = $dom.data('page') || 1;
  const loadPage = currentPage + 1;
  const cardId = $dom.attr('data-cardId');
  const organizationId = $dom.attr('data-organizationId');
  $.ajaxSync.get('/hydra-base-data/api/v1/product/load/list', {page: loadPage, cardId, organizationId}).then(({res}) => {
    isLoading = false;
    $dom.data('page', loadPage);
    const listData = res.data.results.list ? res.data.results.list : [];
    totalPage = res.data.results.pagination.totalPage;
    listData.map((list) => {
      var imgList = list.titleImageUrl ? '<a href="/products/' + list.publishProductId + '"><img src="' + fileDomain + list.imageUrl + '"/></a>' : '';

      var htmlText = '<div class="products-item">' +
                          '<div class="products-images">' +
                              imgList +
                          '</div>' +
                          '<div class="product-name">' +
                              '<a href="/product/' + list.publishProductId + '">'+list.name+'</a>' +
                          '</div>' +
                          '<div class="product-desc">' +
                              '<a href="/product/' + list.publishProductId + '">'+list.description+'</a>' +
                          '</div>' +
                      '</div>';
      $dom.append(htmlText);
    })
  });
}
const init = () => {
  const $wrap = $('.products-list.scroll-loading');
  if ($wrap.length) {
    $(window).on('scroll', () => {
      $wrap.each(function () {
        if (!isLoading && isScrollEnd($(this))) {
          if (!totalPage || totalPage > currentPage) {
            loadNextPage($(this));
          }
        }
      });
    });
  }
};
module.exports = {init};
},{}],13:[function(require,module,exports){
const init = () => {
  for (let i = 1; i <= 10; i++) {
    $(`.sc-icon-system${i}`).addClass(`s3-icon-system${i}`);
  }


  function setLeft(card, left) {
    const firstItem = card.find('.system-item').first();
    firstItem.animate({marginLeft: `${left}px`}, 500);
    card.data('left', left);
    const maxLeft = card.data('maxLeft');
    if (left >= 0) {
      card.find('.view-left-arrow').hide();
    } else {
      card.find('.view-left-arrow').show();
    }
    if (left * (-1) >= maxLeft) {
      card.find('.view-right-arrow').hide();
    } else {
      card.find('.view-right-arrow').show();
    }
  }

  $('.systemLogin-card').on('click', '.view-right-arrow', function () {
    const card = $(this).parents('.systemLogin-card');
    const nowLeft = card.data('left') || 0;
    const newLeft = nowLeft - 600;
    setLeft(card, newLeft);
  }).on('click', '.view-left-arrow', function () {
    const card = $(this).parents('.systemLogin-card');
    const nowLeft = card.data('left') || 0;
    const newLeft = nowLeft + 600;
    setLeft(card, newLeft);
  }).each(function () {
    const lastItem = $(this).find('.system-item').last();
    let mexLeft = lastItem.offset().left - $(this).offset().left - 1200 + 270;
    $(this).data('maxLeft', mexLeft);
  }).each(function () {
    setLeft($(this), 0);
  });
};
module.exports = {init};
},{}]},{},[4])

